import React from "react"
import { Card, CardBody, Col, Button } from "reactstrap"

function Header({ currentView, selectedConfig, onBackToCards, onBackToDetail }) {
  const getTitle = () => {
    if (currentView === 'cards') return 'Configuration Management'
    if (currentView === 'detail' || currentView === 'location-mapping') {
      if (selectedConfig?.title) {
        return selectedConfig.title
      } else if (selectedConfig?.type) {
        return selectedConfig.type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
      }
      return 'Configuration Detail'
    }
    if (currentView === 'editor' || currentView === 'location-mapping-editor') return 'Edit Condition'
    if (currentView === 'followup-delete') return 'Delete Followup'
    if (currentView === 'reopen-manual-review') return 'Reopen Manual Review'
    if (currentView === 'llm-instr-tuning') return 'LLM Instruction Tuning'
    return 'Configuration Management'
  }

  const getBackButton = () => {
    if (currentView === 'detail' || currentView === 'location-mapping' || currentView === 'followup-delete' || currentView === 'reopen-manual-review' || currentView === 'llm-instr-tuning') {
      return (
        <Button color="secondary" size="sm" onClick={onBackToCards}>
          ← Back to Configurations
        </Button>
      )
    }
    if (currentView === 'editor' || currentView === 'location-mapping-editor') {
      return (
        <Button color="secondary" size="sm" onClick={onBackToDetail}>
          ← Back to Configuration Detail
        </Button>
      )
    }
    return null
  }

  return (
    <Card>
      <CardBody>
        <Col>
          <div className="float-start">
            <h5 className="text-primary">{getTitle()}</h5>
          </div>
          <div className="float-end">
            {getBackButton()}
          </div>
        </Col>
      </CardBody>
    </Card>
  )
}

export default Header